import { logger } from '../../services/logger';

export default {
    log(...messages: any[])
    {
        if (true)
        {
            // Wrap ActionCable internal logging with structured logger
            const timestamp = Date.now();
            const messageStr = messages.map(m =>
                typeof m === 'object' ? JSON.stringify(m) : String(m)
            ).join(' ');
            logger.debug(`[WebSocketAction] ${messageStr}`, { timestamp });
        }
    },
};
